<template>
  <section>
    <template v-if="availableInclusions.length">
      <h4 class="fs-20 font-medium mb-4">
        Inclusions
      </h4>

      <checkbox
        v-for="incl in availableInclusions"
        :key="incl.id"
        v-model="options[`opt${incl.id}`]">
        {{ incl.name }}
      </checkbox>
    </template>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

import Checkbox from '../../../components/core/Checkbox'
import ClearFiltersMixin from '../../../mixins/ClearFiltersMixin'

export default {
  mixins: [ClearFiltersMixin],
  components: {
    Checkbox
  },
  data () {
    return {
      options: null
    }
  },
  computed: {
    ...mapGetters(['availableInclusions'])
  },
  methods: {
    loadOptions () {
      const { filters } = this.$store.state
      const selectedInclusions = filters.facilities.split(',')
        .map(x => x)

      const options = this.availableInclusions.reduce((opts, incl) => {
        return Object.assign(opts, {
          [`opt${incl.id}`]: selectedInclusions.includes(incl.id.toString())
        })
      }, {})

      return options
    }
  },
  watch: {
    availableInclusions (availableInclusions) {
      if (availableInclusions.length) {
        this.options = this.loadOptions()
      }
    },
    options: {
      deep: true,
      handler (options) {
        let result = []

        for (const opt in options) {
          if (options[opt]) {
            result.push(opt.substring(3))
          }
        }

        this.$store.commit('setFilter', {
          name: 'facilities',
          value: result.join(',')
        })
      }
    }
  }
}
</script>